import React, { useEffect, useState } from 'react';
import { useBreadcrumbs, useUser } from '../hooks';
import { ListWorker, Worker } from '../SiteClasses';
import { Link, useNavigate } from 'react-router-dom';
import { WorkerModal, DownloadRFCReport } from '../components';
import { bindClick } from '../SiteUtil';
import { Header, Groupper, Button, Table, Pagination, Input, Icon, Label, Modal, Toast } from 'react-frontier';
import { Dropdown } from 'semantic-ui-react';
import UserAccess from '../UserAccess';
import API from '../API';

const PAGE_SIZE = 20;

interface WorkersListProps{
	
}

enum Modals{
	VALIDATE_RFC = 1,
}

var WorkersList = (props: WorkersListProps)=>{
	var { setTitle } = useBreadcrumbs();
	var { hasAccess } = useUser();
	var navigate = useNavigate();
	var [loadError, setLoadError] = useState<string>(null);
	var [loading, setLoading] = useState<boolean>(false);
	var [workersList, setWorkersList] = useState<ListWorker[]>(null);
	var [searchWorkers, setSearchWorkers] = useState<ListWorker[]>(null);
	var [page, setPage] = useState<number>(0);
	var [filter, setFilter] = useState<string>('');
	var [searchTimeout, setSearchTimeout] = useState<any>(null);
	var [searching, setSearching] = useState<boolean>(false);
	var [addWorkerModal, setAddWorkerModal] = useState<boolean>(false);
	var [shownModal, setShownModal] = useState<number>(null);
	var [selectedWorker, setSelectedWorker] = useState<ListWorker>(null);
	var [rfcReportModal, setRfcReportModal] = useState<boolean>(false);

	useEffect(()=>{
		setTitle('Trabajadores');
		get();
	}, []);

	var get = (get_page?: number) => {
		var offset = (get_page > 0) ? Math.max(0, (get_page || page) * PAGE_SIZE) : 0;
		
		setLoading(true);
		API.getWorkers(null, PAGE_SIZE, offset).then(res => {
			if (res.error) return setLoadError(res.message);
			return setWorkersList(res.data);
		}).catch(err => {
			return setLoadError('Hubo un error al obtener los trabajadores. (GES-1)');
		}).finally(()=>{
			setLoading(false);
		})
	};

	var onPageChange = (page: number)=>{
      setLoading(true)
		setPage(page);
		get(page);
	};

	var search = (query: string)=>{
		setSearching(true);
		setSearchTimeout(null);
		API.searchWorkers(query).then(res=>{
			if(res.error) return setLoadError(res.message);
			setSearchWorkers(res.data);
		}).catch(err=>{
			return setLoadError('Hubo un error al buscar el trabajador. (SES-1)');
		}).finally(()=>{
			setSearching(false);
		})
	};

	var onSearchChange = (val: string)=>{
		setFilter(val);
		if(searchTimeout) clearTimeout(searchTimeout);
		if(val.length<3){
			return setSearchWorkers(null);
		}
		setSearchTimeout(setTimeout(()=>{
			search(val)
		}, 500));
	};

	var onCreateWorker = (newWorker: Worker)=>{
		var w = [...workersList];
		w?.push(newWorker)
		setWorkersList(w);
		setAddWorkerModal(false);
		return navigate(`/workers/${newWorker.worker_id}`);
	};

	var downloadReport = ()=>{
		API.downloadWorkersReport().catch(err=>{	
		}).catch(err=>{
			setLoadError('Hubo un error inesperado descargando el reporte (LCL-1)');
		});
	};

	var downloadStatusReport = ()=>{
		API.downloadWorkersStatusReport().then(res=>{
			if(res && res.error) return Toast.error(res.message);
		}).catch(err=>{
			Toast.error('Hubo un error inesperado descargando el reporte (WKS-RPT-1)');
		});
	};

	var showRFCReportModal = ()=>{
		setRfcReportModal(true);
	};

	var onRFCReportComplete = ()=>{
		get(page);
	};

	var showValidateModal = (worker: ListWorker)=>{
		setSelectedWorker(worker);
		setShownModal(Modals.VALIDATE_RFC);
	};

	var validateRFC = ()=>{
		API.validateWorkerRFC([selectedWorker.worker_id]).then(res=>{
			if(res.error) return Toast.error(res.message);
			Toast.success('RFC validado correctamente');

			var w = [...workersList];
			var index = w.findIndex(w=>w.worker_id === selectedWorker.worker_id);
			if(index !== -1){
				w[index].valid_rfc = true;
				setWorkersList(w);
			}
			setShownModal(null);
			setSelectedWorker(null);
			get(page);
		}).catch(err=>{
			Toast.error('Hubo un error al validar el RFC');
		});
	};

	var downloadCIF = (cif_asset_id: number)=>{
		API.downloadWorkerCIF(cif_asset_id).then(res=>{
			if(res && res.error) return Toast.error(res.message);
		}).catch(err=>{
			Toast.error('Hubo un error al descargar el CIF');
		});
	};

	if(loadError) return <Header text='Error' subtext={loadError} />
	if(!workersList) return <Header text='Cargando datos' loading />

	var shown_workers = searchWorkers || workersList;

	return <div>
		<Groupper
			width={750}
			title={'Trabajadores'}
			style={{ marginTop: 20 }}
			titleRight={(
				<Dropdown icon={null} pointing direction='left' trigger={(
					<Button text='Opciones' color='black' iconRight='caret-down' iconRightStyle={{ marginRight: 0, marginLeft: 5 }} size='small'/>
				)}>
					<Dropdown.Menu>
						{hasAccess(UserAccess.WORKERS.CREATE_WORKERS) && (
							<Dropdown.Item text={'Agregar trabajador'} icon={'plus'} onClick={bindClick(setAddWorkerModal, true)}/>
						)}
						{hasAccess(UserAccess.WORKERS.VIEW_BAN_REASONS) && (
							<Dropdown.Item text={'Razones de baneo'} icon={'ban'} as={Link} to={'/reasons'} />
						)}
						{hasAccess(UserAccess.WORKERS.VIEW_WORKERS) && (
							<Dropdown.Item text={'Exportar trabajadores'} icon={'download'} onClick={downloadReport} />
						)}
						{hasAccess(UserAccess.WORKERS.VALIDATE_RFC) && (
							<Dropdown.Item text={'Descarga validacion rfc'} icon={'download'} onClick={showRFCReportModal} />
						)}
						{hasAccess(UserAccess.WORKERS.VIEW_WORKERS) && (
							<Dropdown.Item text={'Reporte Operaciones'} icon={'chart bar'} onClick={downloadStatusReport} />
						)}
					</Dropdown.Menu>
				</Dropdown>
			)}
		>
			<Input placeholder='Buscar...' value={filter} onChange={onSearchChange} style={{ marginBottom: 15 }} />
			<Table
				striped
				className='first last'
				headers={['ID', 'Nombre', 'Apellido', 'Ciudad', 'RFC','Estatus', <Icon name='wrench' />]}
				collapsingIndexes={[5, 6]}
				centeredIndexes={[5]}
				footer={(!!shown_workers && shown_workers.length >= PAGE_SIZE || page !== 0) && (
					<Table.Cell colSpan={10} row>
						<div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
							<Pagination page={page} onPageChange={onPageChange} hasNext={shown_workers.length>=PAGE_SIZE} />
						</div>
					</Table.Cell>
				)}
			>
				{searching || loading ? (
					<Table.Cell row className='empty' colSpan={8}>
						<Header loading text='Cargando datos' />
					</Table.Cell>
				) : (
					shown_workers.length !== 0 ? (
						shown_workers.map(w => (
							<Table.Row
								key={w.worker_id}
								collapsingIndexes={[0, 4, 6]}
								data={[
									w.worker_id,
									w.first_name,
									w.last_name,
									w.city,
									<Icon 
										name={!w.cif_asset_id && !w.valid_rfc ? 'close' : 'check'} 
										color={!w.cif_asset_id && !w.valid_rfc ? 'red' : (w.cif_asset_id && !w.valid_rfc ? 'orange' : 'green')} 
									/>,
								<Label style={{ padding: '1px 10px', fontSize: 12, minWidth: 95 }} color={w.ban_reason ? 'red' : (w.onboarded ? 'green' : 'red')}>
									<Icon name={w.ban_reason ? 'ban' : (w.onboarded ? 'check-circle' : 'triangle-exclamation')} />
									{w.ban_reason ? 'Baneado' : (!w.onboarded ? 'Pendiente' : 'Activo')}
								</Label>,
									<Dropdown icon={(
										<div className="fr label" style={{ padding: '3px 10px' }}>
											<Icon name='ellipsis' style={{ margin: 0 }} />
										</div>
									)} className='icon'>
										<Dropdown.Menu>
											<Dropdown.Item as={Link} to={`/workers/${w.worker_id}`}>
												<Icon name="eye" style={{ marginRight: 3 }} /> Ver
											</Dropdown.Item>
											{hasAccess(UserAccess.WORKERS.VALIDATE_RFC) && !w.valid_rfc && w.cif_asset_id ? (
												<Dropdown.Item onClick={() => showValidateModal(w)}>
													<Icon name="check" style={{ marginRight: 3 }} /> Validar RFC
												</Dropdown.Item>
											) : null}
											{w.cif_asset_id ? (
												<Dropdown.Item onClick={() => downloadCIF(w.cif_asset_id)}>
													<Icon name="download" style={{ marginRight: 3 }} /> Descargar PDF
												</Dropdown.Item>
											) : null}
										</Dropdown.Menu>
									</Dropdown>
								]}
							/>
						))
					) : (
						<Table.Cell row className='empty' colSpan={7}>
							No se encontraron registros
						</Table.Cell>
					)
				)}
			</Table>
		</Groupper>
		<WorkerModal
			open={addWorkerModal}
			onClose={bindClick(setAddWorkerModal, false)}
			onCreate={(w) => onCreateWorker(w)}
		/>
		<Modal open={shownModal === Modals.VALIDATE_RFC} onClose={bindClick(setShownModal, null)} size='tiny'>
			<Modal.Header>Validar RFC</Modal.Header>
			<Modal.Content>
				<Header text={`¿Marcar el RFC como válido?`} />
				{selectedWorker && (
					<Table
						details
						data={[
							['ID', selectedWorker.worker_id],
							['Nombre', `${selectedWorker.first_name} ${selectedWorker.last_name}`],
							['RFC', selectedWorker.rfc]
						]}
					/>
				)}
			</Modal.Content>
			<Modal.Actions>
				<Button text='Cancelar' basic onClick={bindClick(setShownModal, null)} />
				<Button text='Guardar' color='black' onClick={validateRFC} />
			</Modal.Actions>
		</Modal>
		<DownloadRFCReport
			open={rfcReportModal}
			onClose={bindClick(setRfcReportModal, false)}
			onComplete={onRFCReportComplete}
		/>
	</div>
}

export default WorkersList;